export const EXTERNAL_REPORT_TYPE = 'standard';
export const PHOTO_TYPE_WORK_PROGRESS = '作業状況';
export const PHOTO_TYPE_ABNORMAL = '異常箇所';

export const EXTERNAL_REPORT_CONTENTS_OTHER = 'その他';
export const CONNECTION_CHAR_FOR_JOIN_ROADS_CONTENTS = ', ';
